// TODO:区分コード管理.xlsx参考
/**
 *  M0001	請求書作成区分
 */
export const e請求書作成区分 = {
  受注配車: "1",
  月固定: "2",
  手作成: "3",
} as const

export type T請求書作成区分名称 = keyof typeof e請求書作成区分
export type T請求書作成区分 = (typeof e請求書作成区分)[T請求書作成区分名称]

// M0002	締日区分
// M0003	計上基準日区分
export const e計上基準日区分 = {
  積日: "11",
  卸日: "12",
  PICK日: "21",
  作業日: "22",
  返却日: "23",
} as const

export type T計上基準日区分名称 = keyof typeof e計上基準日区分
export type T計上基準日区分 = (typeof e計上基準日区分)[T計上基準日区分名称]
export const e海コン計上基準日区分 = {
  PICK日: "21",
  作業日: "22",
  返却日: "23",
} as const

export type T海コン計上基準日区分名称 = keyof typeof e海コン計上基準日区分
export type T海コン計上基準日区分 =
  (typeof e海コン計上基準日区分)[T海コン計上基準日区分名称]
// M0004	請求車輌区分
export const e請求車輌区分 = {
  ヘッド: "1",
  トレーラー: "2",
} as const

// M0005	請求書印刷区分
export const e請求書印刷区分 = {
  表紙_明細別印刷: "1",
  明細のみ印刷_表紙合体: "2",
} as const
// M0006	明細小計表示区分
// M0007	消費税表示区分
// M0008	消費税計算区分

export const e消費税計算区分 = {
  四捨五入: "1",
  切り捨て: "2",
  切り上げ: "3",
} as const
export type T消費税計算区分名称 = keyof typeof e消費税計算区分
export type T消費税計算区分 = (typeof e消費税計算区分)[T消費税計算区分名称]

// M0009	口座種別区分
// M0010	単位区分
// M0011	支払先区分
export const e支払先区分 = {
  傭車先: "1",
  メーカー: "2",
  整備会社: "3",
  購買先: "4",
} as const

export type T支払先区分名称 = keyof typeof e支払先区分
export type T支払先区分 = (typeof e支払先区分)[T支払先区分名称]

// M0012	採番区分

// M0017 休日区分
export const e休日区分 = {
  祝日: "1",
  所定休日: "2",
  会社休日: "3",
} as const
export type T休日区分名称 = keyof typeof e休日区分
export type T休日区分 = (typeof e休日区分)[T休日区分名称]

// M0018 メニュー分類区分
export const eメニュー分類区分 = {
  PC: "1",
  タブレット: "2",
} as const
export type Tメニュー分類区分名称 = keyof typeof eメニュー分類区分
export type Tメニュー分類区分 =
  (typeof eメニュー分類区分)[Tメニュー分類区分名称]

// M00019 お知らせ分類区分
export const eお知らせ分類区分 = {
  システム関連: "1",
  社内周知: "2",
  締切関連: "3",
  注意事項: "4",
  行事予定: "5",
}
export type Tお知らせ分類区分名称 = keyof typeof eお知らせ分類区分
export type Tお知らせ分類区分 =
  (typeof eお知らせ分類区分)[Tお知らせ分類区分名称]

// M00020 締め確定区分
export const e締め確定区分 = {
  月報締め処理: "1",
  乗務員出勤簿: "2",
  事務員出勤簿: "3",
  受注配車入力: "4",
  海コン受注配車入力: "5",
  乗務員給与締め処理: "6",
}
export type T締め確定区分名称 = keyof typeof e締め確定区分
export type T締め確定区分 = (typeof e締め確定区分)[T締め確定区分名称]
